import React from "react";
import { useTranslation } from "react-i18next";
import "./listModules.scss";


const ModuleItem = ({ className, title, children }) => (
  <div className={className}>
    <div>
      <h1>{title}</h1>
    </div>
    <div>
      {children}
    </div>
  </div>
)


function ListModules() {
  const { t } = useTranslation()


  return (
    <div className="container-list-modules">
      <div className="list-one">

        <ModuleItem className={`audit`} title="AUDIT">
          <p>{t('modules.audit_text_1')}</p>
          <p>{t('modules.audit_text_2')}</p>
        </ModuleItem>

        <ModuleItem className={`fraud`} title="FRAUD">
          <p>{t("modules.fraud_text")}</p>
        </ModuleItem>

        <ModuleItem className={`risk-compliance-desk`} title="RISK & COMPLIANCE">
          <p>{t('modules.compliance_text')}</p>
        </ModuleItem>
      </div>

      <div className="list-two">
        <ModuleItem className={"indicator"} title="INDICATOR">
          <p>{t('modules.indicator_text_1')}</p>
          <p>{t('modules.indicator_text_2')}</p>
        </ModuleItem>

        <ModuleItem className={"dashboard"} title="DASHBOARD">
          <p>{t('modules.dashboard_text')}</p>
        </ModuleItem>


        <ModuleItem className={"machine-learn-desk"} title="MACHINE LEARNING" >
          <p>{t("modules.machine_learn_text_1")}</p>
          <p>{t("modules.machine_learn_text_2")}</p>
        </ModuleItem>
      </div>

      <div className="list-three">
        <ModuleItem className="analysis" title="ANALYSIS">
          <p>{t('modules.analysis_text_1')}</p>
          <p>{t('modules.analysis_text_2')}</p>
        </ModuleItem>

        <ModuleItem className="big-data" title="BIG DATA" >
          <p>{t('modules.bigdata_text_1')}</p>
          <p>{t('modules.bigdata_text_2')}</p>
        </ModuleItem>

        <ModuleItem className="chatbots-desk" title="CHATBOTS">
          <p>{t('modules.chatbot_text')}</p>
        </ModuleItem>
      </div>

      <div className="list-four">

        <ModuleItem className="workflow" title="WORKFLOW">
          <p>{t("modules.workflow_text_1")}</p>
          <p>{t("modules.workflow_text_2")}</p>
        </ModuleItem>

        <ModuleItem className="security" title="SECURITY">
          <p>{t("modules.security_text_1")}</p>
          <p>{t("modules.security_text_2")}</p>
          <p>{t("modules.security_text_3")}</p>
        </ModuleItem>


        <ModuleItem className="scheduler-desk" title="SCHEDULER" >
          <p>{t("modules.scheduler_text_1")}</p>
          <p>{t("modules.scheduler_text_2")}</p>
        </ModuleItem>
      </div>

      {/* criar para mobile list five e six e adicionar div's terceiras divs que estão com display none mob. Colocar lists five e six com display none para desktop */}

      <div className="list-five-mobile">
        <ModuleItem className={"chatbots-mobile"} title={"CHATBOTS"} >
          <p>{t('modules.chatbot_text')}</p>
        </ModuleItem>

        <ModuleItem className={"machine-learn-mobile"} title="ML">
          <p>{t("modules.machine_learn_text_1")}</p>
          <p>{t("modules.machine_learn_text_2")}</p>
        </ModuleItem>
      </div>

      <div className="list-six-mobile">
        <ModuleItem className={"scheduler-mobile"} title="SCHEDULER">
          <p>{t("modules.scheduler_text_1")}</p>
          <p>{t("modules.scheduler_text_2")}</p>
        </ModuleItem>


        <ModuleItem className="risk-compliance-mobile" title="RISK & COMPLIANCE">
          <p>{t('modules.compliance_text')}</p>
        </ModuleItem>
      </div>
    </div>
  );
}

export default ListModules;
